export default __webpack_public_path__ + "static/media/49_BottomLeftSquares_Bottom.6662537b.mp4";